var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Phone receiver silhouette",
    clipPath: "url(#clip0_50_2337)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.2859 11.6361C13.3193 10.8094 12.3384 10.3086 11.3837 11.1341L10.8136 11.633C10.3965 11.9951 9.62104 13.6872 6.62272 10.2381C3.62502 6.79332 5.40891 6.25697 5.82662 5.89794L6.39981 5.39843C7.34951 4.57112 6.99111 3.52963 6.30615 2.45755L5.89281 1.80819C5.20473 0.738608 4.45546 0.0361689 3.50327 0.862237L2.98877 1.3118C2.56793 1.61837 1.39158 2.6149 1.10623 4.50805C0.762819 6.77958 1.84614 9.38079 4.32809 12.2349C6.80692 15.0902 9.23392 16.5244 11.5329 16.4995C13.4436 16.4789 14.5974 15.4536 14.9583 15.0809L15.4747 14.6307C16.4244 13.8052 15.8343 12.9648 14.8672 12.1362L14.2859 11.6361Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_50_2337"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneWhite);
export default __webpack_public_path__ + "static/media/phone-white.21cdbb60c4f760736b2faecb435be813.svg";
export { ForwardRef as ReactComponent };